import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";
import {
  stickyHeaderCell,
  stickyTableCell,
  tableCell,
} from "../../../../styles/sharedTableStyles.css";

export const playerProfileTablesWrapper = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space.xs,
});

export const toggleButtonGroupWrapper = style({
  width: "100%",
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      width: "402px",
    },
  },
});

export const tablesWrapper = style({
  width: "100%",
});

export const historyTablesWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const tableHeader = style({
  marginBottom: vars.space.s,
  fontSize: vars.fontSizes.heading.m,
});

export const oppHeaderCell = style([
  stickyHeaderCell,
  {
    paddingInlineStart: 16,
    paddingInlineEnd: 16,
    textAlign: "start",
  },
]);

export const per90HeaderCell = style([
  stickyTableCell,
  {
    textAlign: "end",
    fontWeight: "normal",
  },
]);

export const per90Cell = style([tableCell]);

export const kickoffTimeCell = style([
  tableCell,
  {
    width: "100%",
  },
]);

export const fdrCell = style([
  tableCell,
  {
    padding: `${vars.space.s} ${vars.space.xs}`,
  },
]);

export const badgeWrap = style({
  width: "2.4rem",
  height: "2.4rem",
});
